import { useI18n } from 'vue-i18n'
import { useLayoutStore } from '~/stores/layout'
import useContactPointJsonLd from '~/composables/useContactPointJsonLd'

export default () => {
    const config = useRuntimeConfig()
    const i18n = useI18n()
    const layoutStore = useLayoutStore()

    return {
        '@type': 'WebSite',
        url: config.public.apiUrl,
        name: i18n.t('mainTitle'),
        '@id': `${config.public.apiUrl}#website`,
        publisher: {
            '@type': 'Organization',
            name: i18n.t('mainTitle'),
            '@id': `${config.public.apiUrl}#publisher`,
            alternateName: 'Pilulka lékárny a.s.',
            sameAs: layoutStore.socialProfiles,
            logo: {
                '@type': 'ImageObject',
                url: `${config.public.apiUrl}/nuxt-assets/images/logo/pilulka.svg`,
            },
            contactPoint: useContactPointJsonLd(),
        },
    }
}
